import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.529 10.862a.666.666 0 1 1 .942.943l-2.667 2.667a.667.667 0 0 1-.942 0l-1.333-1.334-.086-.105a.667.667 0 0 1 .924-.924l.104.086.862.862zm-3.53-6.195V4H6v.667a.666.666 0 0 1-1.332 0V4H4a.666.666 0 0 0-.666.667v2h9.333v-2A.667.667 0 0 0 12 4h-.666v.667a.667.667 0 0 1-1.334 0m4 4a.666.666 0 1 1-1.332 0V8H3.334v4.667a.666.666 0 0 0 .666.666h3.667a.667.667 0 0 1 .134 1.32l-.134.014H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h.667V2A.667.667 0 0 1 6 2v.667h4V2a.667.667 0 0 1 1.334 0v.667H12a2 2 0 0 1 2 2z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })